import React from 'react';

function MakeMeOwnerButton({ value, onChange, disabled, currentUserId }) {
  const isSelf = String(value ?? '') === currentUserId;
  const isButtonDisabled = disabled || isSelf;

  return (
    <button
      type="button"
      data-test="workkard-form-make-me-owner"
      onClick={() => onChange(currentUserId)}
      disabled={isButtonDisabled}
      className={isButtonDisabled ? 'btn-cc btn-cc__disabled' : 'btn-cc btn-cc__primary'}
    >
      Make me owner
    </button>
  );
}

export default MakeMeOwnerButton;
